import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { NavbarComponent } from "../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../layout/sidebar/sidebar.component";
import { RoutelinksService } from '../../services/core/routelinks.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LauncerService } from '../../services/launcer.service';
import { ParamLauncherResponseDto } from '../../models/launcher/paramLauncherResponseDto';
import { CommonModule, formatDate } from '@angular/common';
import { EnrollmentFeeDiscountsRequest } from '../../models/launcher/enrollmentFeeDiscountsRequest';
import { EnrollmentFeeDiscountsResponse } from '../../models/launcher/enrollmentFeeDiscountsResponse';
import { SpinnerModalComponent } from "../spinner-modal/spinner-modal.component";
import { SharedService } from '../../services/shared.service';
import { RateModelDto } from '../../models/ratemodeldto';

@Component({
  selector: 'app-launcher',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, ReactiveFormsModule, TranslatePipe, CommonModule, FormsModule, SpinnerModalComponent],
  templateUrl: './launcher.component.html',
  styleUrl: './launcher.component.css'
})
export class LauncherComponent {

  links: any[] = []; // Lista de links para el sidebar

  langChangeSubscription!: Subscription;

  paramLauncherResponseDto: ParamLauncherResponseDto = new ParamLauncherResponseDto();

  validateLaunchForm!: FormGroup;

  validateProductOrSubject!: FormGroup;

  newInput: string[] = [];

  enrollmentFeeDiscountsResponse: EnrollmentFeeDiscountsResponse = new EnrollmentFeeDiscountsResponse();

  formSubmit!: boolean;

  currentLanguage: string = 'es';

  initRateModelDto: RateModelDto[] = [];

  filteredRateModels!: RateModelDto[];

  constructor(private routelinks: RoutelinksService,
    private changeDetector: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private launcherService: LauncerService,
    private sharedShervice: SharedService) {
  }


  ngOnInit(): void {
    // Inicializa la propiedad en ngOnInit
    this.links = this.routelinks.linksLauncher;
    this.initFormReactiveLauncher();
    this.getParamInit();
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
      this.changeDetector.detectChanges();
      this.getParamInit();
    });

    // Dada la tipología, filtramos los modelos
    this.validateLaunchForm.get('typology')?.valueChanges
      .subscribe(value => {

        // Obtenemos el listado inicial de todos los modelos para su posterior filtrado.
        this.paramLauncherResponseDto.paramLauncherDto.rateModelDto = this.initRateModelDto;
        const rmFilter = this.paramLauncherResponseDto.paramLauncherDto.rateModelDto.filter((rm: any) => {
          return rm.typology.includes(value);
        });
        this.filteredRateModels = rmFilter;
      });
  }

  private initFormReactiveLauncher(): void {
    this.validateLaunchForm = this.formBuilder.group({
      idpStudent: ['', [Validators.required]],
      referenceDate: ['', [Validators.required]],
      idProductOrSubject: ['', [Validators.required]],
      numberTimesProductoOrSubjectRegistered: ['', [Validators.required]],
      numberCreditsForProductOrSubject: ['', [Validators.required]],
      typeRegistrationProcess: ['', [Validators.required]],
      typology: ['', [Validators.required]],
      rateModelCode: ['', [Validators.required]],
      chargeLearningResources: ['', [Validators.required]],
      learningResourceType: ['C', Validators.required],
      statusProductOrSubject: ['', [Validators.required]],
      isoLanguageCode: [''],
      academicRateType: ['N', Validators.required],
      experimentalCodeOfficialRegistration: [''],
      cycleCodeOfficialRegistration: ['']
    });
  }


  getParamInit() {
    this.launcherService.getParamForLauncher().subscribe({
      next: response => {
        if (response.paramLauncherDto != null) {
          this.paramLauncherResponseDto.paramLauncherDto = response.paramLauncherDto;

          this.paramLauncherResponseDto.paramLauncherDto.rateModelDto =
            // Filtramos el idioma el cual está ejecutandose la aplicación
            this.paramLauncherResponseDto.paramLauncherDto.rateModelDto.map((rm: any) => {
              return {
                ...rm,
                rateModelTraductionDto: rm.rateModelTraductionDto.filter((rmt: any) => rmt.languageDto.code.includes(this.currentLanguage))
              }
            });

          // ordenamos por id del modelo de tasa
          this.paramLauncherResponseDto.paramLauncherDto.rateModelDto.sort((a: any, b: any) => a.idRateModel - b.idRateModel);

          // Almacenamos el listado de modelos inicial para su posterir filtrado
          this.initRateModelDto = this.paramLauncherResponseDto.paramLauncherDto.rateModelDto;

          this.validateLaunchForm.patchValue({
            isoLanguageCode: 'es',
            academicRateType: 'N',
            learningResourceType: 'C'
          });
        }
      }
    });
  }


  onSubmit(): void {
    this.formSubmit = true;
    if (this.validateLaunchForm.invalid) {
      this.validateLaunchForm.markAllAsTouched();
      return;
    }
    const enrollmentFeeDiscountsRequest: EnrollmentFeeDiscountsRequest = {
      idpStudent: this.validateLaunchForm.value.idpStudent,
      referenceDate: formatDate(this.validateLaunchForm.value.referenceDate, 'yyyy-MM-dd', 'en-US'),
      typeRegistrationProcess: this.validateLaunchForm.value.typeRegistrationProcess,
      typology: this.validateLaunchForm.value.typology,
      rateModelCode: this.validateLaunchForm.value.rateModelCode,
      cycleCodeOfficialRegistration: this.validateLaunchForm.value.cycleCodeOfficialRegistration,
      experimentalCodeOfficialRegistration: this.validateLaunchForm.value.experimentalCodeOfficialRegistration,
      isoLanguageCode: this.validateLaunchForm.value.isoLanguageCode,
      listProductsOrSubjectsOfRegistration: [
        {
          idProductOrSubject: this.validateLaunchForm.value.idProductOrSubject,
          academicRateType: this.validateLaunchForm.value.academicRateType,
          numberTimesProductoOrSubjectRegistered: this.validateLaunchForm.value.numberTimesProductoOrSubjectRegistered,
          numberCreditsForProductOrSubject: this.validateLaunchForm.value.numberCreditsForProductOrSubject,
          chargeLearningResources: this.validateLaunchForm.value.chargeLearningResources,
          learningResourceType: this.validateLaunchForm.value.learningResourceType,
          statusProductOrSubject: this.validateLaunchForm.value.statusProductOrSubject
        }
      ]
    };
    this.sharedShervice.showSpinnerModal();
    this.launcherService.consultPotentialCalculation(enrollmentFeeDiscountsRequest).subscribe({
      next: response => {
        if (response != null) {
          console.log(response);
          this.enrollmentFeeDiscountsResponse = response;
          this.sharedShervice.hideSpinnerModal();
          
          // Agregamos en los observables las tasas admin opcionales y descuentos para utilizarlos posteriormente en el calculo de matrícula
          this.sharedShervice.setInitTaxAdminOptionalCalcPotential(this.enrollmentFeeDiscountsResponse.listOptionalAdministrativeFee);
          this.sharedShervice.setInitSelectDiscountCalcPotential(this.enrollmentFeeDiscountsResponse.listCurrentDiscount);
        }
      }, error: error => {
        console.log(error);
        this.sharedShervice.hideSpinnerModal();
      }
    });

  }


  /**
   * Función encargada de trabajar con valores numéricos dentro de los input de texto
   * @param event 
   */
  validateIdp(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Eliminamos las letras y permitismo un total de 30 digitos
    const cleaned = input.value.replace(/\D/g, '').slice(0, 30);
    input.value = cleaned;
    this.validateLaunchForm.get('idpStudent')?.setValue(cleaned);
  }


  public statusLabelKey: Record<string, string> = {
    N: 'launcher.statusNormal',
    V: 'launcher.statusValidated',
    A: 'launcher.statusAdapted',
    C: 'launcher.statusChained'
  };

  public learningKey: Record<string, string> = {
    S: 'launcher.learningResourcesYes',
    N: 'launcher.learningResourcesNo'
  }

  public processTipeKey: Record<string, string> = {
    A: 'launcher.processTipeHight',
    M: 'launcher.processTipeModification'
  }




}

